"use client";

import { Modal } from "@/components/primitives/Modal";
import { WaitlistForm } from "@/components/forms/WaitlistForm";
import { getFormsCopy } from "@/content/forms";
import { useLocale } from "@/lib/i18n/provider";

type Props = {
  open: boolean;
  onClose: () => void;
  source: string;
  platform?: "ios" | "android";
  country?: string | null;
};

/** Waitlist capture used while a store listing is unpublished in the visitor country. */
export function WaitlistModal({
  open,
  onClose,
  source,
  platform,
  country,
}: Props) {
  const { locale } = useLocale();
  const forms = getFormsCopy(locale);

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={forms.modals.iosWaitlist.title}
      description={forms.modals.iosWaitlist.description}
    >
      <WaitlistForm
        source={source}
        layout="stacked"
        waitlistPlatform={platform}
        waitlistCountry={country}
      />
    </Modal>
  );
}
